import { ProjectIssue } from '../model/entities';
import { Page } from '../model/elements';
import { proxyApiAxios } from './CustomAxios';
import { ProjectIssueStatus } from '../model/types';

class ProjectIssueApi {
    list = async (
        page: number,
        size: number,
        sortField: string,
        sortOrder: boolean,
        hubId: string,
        projectId: string,
        status?: ProjectIssueStatus,
        typeId?: string,
        subtypeId?: string,
        searchText?: string,
    ): Promise<Page<ProjectIssue>> => {
        const response = await proxyApiAxios.get<Page<ProjectIssue>>('/project-issues', {
            params: { page, size, sortField, sortOrder, hubId, projectId, status, typeId, subtypeId, searchText },
        });
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;

        return response.data;
    };
}

const projectIssueApi: ProjectIssueApi = new ProjectIssueApi();
export default projectIssueApi;
